import React from "react";
import Loading from "components/common/loading/Loading";

import useSubscribeSettingForm from "./form/useSubscribeSettingForm";
import NotificationChannels from "./notificationChannels/NotificationChannels";
import ReminderSchedule from "./reminderSchedule/ReminderSchedule";
import { Button, Grid } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import SubmitButton from "components/Button/SubmitButton";
import SubscriptionControl from "./subscriptionControl/SubscriptionControl";
import SubscibeInfoAlert from "./alert/SubscriptionInfoAlert";
import useDisconnectHistory from "components/pages/transmissions/modal/patient/tabs/subscription/disconnectHistory/useDisconnectHistory";

const SubscribeSetting = () => {
  const {
    isPauseActive,
    isPauseStartDateLocked,
    isLoading,
    isEditMode,
    lastSendInfoText,
    subscribeSetting,
    optOutInfoText,
    isSubmitClicked,

    handleCancel,
    handleSubmit,
    handleChange,
    setIsEditMode,
    setIsSubmitClicked,
  } = useSubscribeSettingForm();
  const { resolved } = useDisconnectHistory();

  if (isLoading) {
    return <Loading height="100px" />;
  }

  return (
    <div>
      {(optOutInfoText || lastSendInfoText || resolved.length > 0) && (
        <Grid container className="mb-3 mt-3">
          <Grid item xs={12}>
            <SubscibeInfoAlert
              optOutInfoText={optOutInfoText}
              lastSendInfoText={lastSendInfoText}
            />
          </Grid>
        </Grid>
      )}

      <div className="d-flex justify-between">
        <div>
          <p className="patient-form__info--header" style={{ marginBottom: 0 }}>
            Subscribe Setting
          </p>
          <p
            className="patient-form__info--subheader"
            style={{ marginBottom: "16px" }}
          >
            Manage how and when you receive automated notifications.
          </p>
        </div>

        {!isEditMode && (
          <Button
            variant="text"
            color="secondary"
            className="device-edit-button"
            onClick={() => setIsEditMode(true)}
          >
            <EditIcon className="patient-edit-icon billing-cycle-edit-icon" />
            Edit
          </Button>
        )}
      </div>

      <NotificationChannels
        isEdit={isEditMode}
        values={subscribeSetting.notification_channels}
        handleChange={handleChange}
      />

      <ReminderSchedule
        isPauseActive={isPauseActive}
        isEdit={isEditMode}
        values={subscribeSetting}
        handleChange={handleChange}
      />

      {(subscribeSetting.disable_configuration || isEditMode) && (
        <SubscriptionControl
          isEdit={isEditMode}
          values={subscribeSetting}
          handleChange={handleChange}
          isSubmitClicked={isSubmitClicked}
          setIsSubmitClicked={setIsSubmitClicked}
          isPauseStartDateLocked={isPauseStartDateLocked}
        />
      )}

      {isEditMode && (
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          className="mt-3"
        >
          <Button
            style={{ marginRight: "10px" }}
            variant="outlined"
            color="secondary"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <SubmitButton
            variant="contained"
            color="secondary"
            handleClick={handleSubmit}
          />
        </Grid>
      )}
    </div>
  );
};

export default SubscribeSetting;
